/**
 * Default application settings used when no user-specific settings
 * are available. Currently stores the default calendar view preference.
 *
 * @type {{
 *   calendar: {
 *     defaultView: string
 *   }
 * }}
 */
export const Settings = {
  calendar: {
    defaultView: "list",
  },
};